// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.download-form {
  width: 90%;
  background-color: #e8e9ea;
  border-radius: 10px;
  border: 10px solid #00468c;
  margin: 0 2rem;
  padding: 1rem;
  font-family: Arial, sans-serif;
}

.download-form-grid {
  display: grid;
  justify-content: center;
  grid-template-columns: repeat(3, minmax(20%, 1fr));
  gap: 2%;
  padding: 2%;
}

.download-form-group {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 1rem;
}

.download-form-group label {
  width: 100%;
  font-weight: bold;
  text-align: left;
  margin-left: 15%;
}

.download-form-group input {
  width: 80%;
  padding: 2%;
}

.download-line-items-wrapper {
  max-height: 200px;
  padding: 2%;
  margin: 2%;
  border: 1px solid #000;
  overflow-y: auto;
}

.download-line-items-section {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.download-line-item-row {
  display: flex;
  align-items: flex-end;
  gap: 0.5rem;
}

.download-line-item-row input {
  padding: 2%;
}

.download-input-group label,
.download-line-item-row label {
  font-weight: bold;
}

.download-serial-number-field,
.download-description-field,
.download-qty-field,
.download-amount-field,
.download-total-field {
  display: flex;
  flex-direction: column;
  flex: 1 1;
}

.download-add-button-cell {
  width: 30px;
  display: flex;
  align-items: flex-end;
  padding-top: 1rem; /* aligns the button with input bottoms */
}

.download-add-line-item-btn {
  width: 100%;
  padding: 4px;
  font-size: 1.2rem;
  background-color: #7fbd2c;
  color: white;
  border: 1px solid #ccc;
  border-radius: 20px;
  cursor: pointer;
}

.download-invoice-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  margin: 2rem 2%;
}

.download-terms-conditions {
  flex: 1 1;
}

.download-terms-conditions textarea {
  width: 90%;
  height: 210px;
  resize: vertical;
}

.download-char-counter {
  font-size: 0.85rem;
  color: #555;
  text-align: right;
  margin-top: 0.25rem;
  margin-right: 10%;
}

.download-totals {
  flex: 1 1;
}

.download-summary-excluding {
  margin-bottom: 1rem;
}

.download-input-group > div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 1rem 3rem;
}

.download-input-group input {
  padding: 2%;
}

.download-gst-group {
  width: 172px;
  display: flex;
  align-items: center;
  background-color: #fff;
  gap: 0.5rem;
  padding: 1%;
  border: 1px solid #000;
}

.download-gst-group input {
  width: 80px;
}

.download-input input {
  width: 50px;
}

.download-percent {
  font-weight: bold;
}

.download-checkbox-group {
  display: flex;
  justify-content: center;
  margin-top: 2rem;
}

.download-checkbox-group label {
  margin: 0 1%;
}

.download-form-actions {
  display: flex;
  gap: 5rem;
  justify-content: center;
  margin-top: 2rem;
}

.download-form-actions button {
  padding: 0.6rem 1.2rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.download-form-actions button[type="submit"] {
  background-color: #7fbd2c;
  color: white;
}

.download-form-actions button[type="button"] {
  background-color: none;
  border: 2px solid #7fbd2c;
  width: 100px;
}
`, "",{"version":3,"sources":["webpack://./src/components/UpdateProjects/DownloadForm.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;EAC1B,cAAc;EACd,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kDAAkD;EAClD,OAAO;EACP,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,UAAU;EACV,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;;;;EAKE,aAAa;EACb,sBAAsB;EACtB,SAAO;AACT;;AAEA;EACE,WAAW;EACX,aAAa;EACb,qBAAqB;EACrB,iBAAiB,EAAE,yCAAyC;AAC9D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,UAAU;EACV,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;AACd","sourcesContent":[".download-form {\n  width: 90%;\n  background-color: #e8e9ea;\n  border-radius: 10px;\n  border: 10px solid #00468c;\n  margin: 0 2rem;\n  padding: 1rem;\n  font-family: Arial, sans-serif;\n}\n\n.download-form-grid {\n  display: grid;\n  justify-content: center;\n  grid-template-columns: repeat(3, minmax(20%, 1fr));\n  gap: 2%;\n  padding: 2%;\n}\n\n.download-form-group {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.download-form-group label {\n  width: 100%;\n  font-weight: bold;\n  text-align: left;\n  margin-left: 15%;\n}\n\n.download-form-group input {\n  width: 80%;\n  padding: 2%;\n}\n\n.download-line-items-wrapper {\n  max-height: 200px;\n  padding: 2%;\n  margin: 2%;\n  border: 1px solid #000;\n  overflow-y: auto;\n}\n\n.download-line-items-section {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.download-line-item-row {\n  display: flex;\n  align-items: flex-end;\n  gap: 0.5rem;\n}\n\n.download-line-item-row input {\n  padding: 2%;\n}\n\n.download-input-group label,\n.download-line-item-row label {\n  font-weight: bold;\n}\n\n.download-serial-number-field,\n.download-description-field,\n.download-qty-field,\n.download-amount-field,\n.download-total-field {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n\n.download-add-button-cell {\n  width: 30px;\n  display: flex;\n  align-items: flex-end;\n  padding-top: 1rem; /* aligns the button with input bottoms */\n}\n\n.download-add-line-item-btn {\n  width: 100%;\n  padding: 4px;\n  font-size: 1.2rem;\n  background-color: #7fbd2c;\n  color: white;\n  border: 1px solid #ccc;\n  border-radius: 20px;\n  cursor: pointer;\n}\n\n.download-invoice-summary {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 2rem;\n  margin: 2rem 2%;\n}\n\n.download-terms-conditions {\n  flex: 1;\n}\n\n.download-terms-conditions textarea {\n  width: 90%;\n  height: 210px;\n  resize: vertical;\n}\n\n.download-char-counter {\n  font-size: 0.85rem;\n  color: #555;\n  text-align: right;\n  margin-top: 0.25rem;\n  margin-right: 10%;\n}\n\n.download-totals {\n  flex: 1;\n}\n\n.download-summary-excluding {\n  margin-bottom: 1rem;\n}\n\n.download-input-group > div {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 1rem 3rem;\n}\n\n.download-input-group input {\n  padding: 2%;\n}\n\n.download-gst-group {\n  width: 172px;\n  display: flex;\n  align-items: center;\n  background-color: #fff;\n  gap: 0.5rem;\n  padding: 1%;\n  border: 1px solid #000;\n}\n\n.download-gst-group input {\n  width: 80px;\n}\n\n.download-input input {\n  width: 50px;\n}\n\n.download-percent {\n  font-weight: bold;\n}\n\n.download-checkbox-group {\n  display: flex;\n  justify-content: center;\n  margin-top: 2rem;\n}\n\n.download-checkbox-group label {\n  margin: 0 1%;\n}\n\n.download-form-actions {\n  display: flex;\n  gap: 5rem;\n  justify-content: center;\n  margin-top: 2rem;\n}\n\n.download-form-actions button {\n  padding: 0.6rem 1.2rem;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.download-form-actions button[type=\"submit\"] {\n  background-color: #7fbd2c;\n  color: white;\n}\n\n.download-form-actions button[type=\"button\"] {\n  background-color: none;\n  border: 2px solid #7fbd2c;\n  width: 100px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
